import { Environment, Float } from "@react-three/drei";
import { useState } from "react";
import { Packaging } from "./Packaging";

export default function Experience() {
  const [isClosed, setIsClosed] = useState(true);

  return (
    <>
      <ambientLight intensity={1.0} />
      <Environment environmentIntensity={2} files={"/venice_sunset_1k.jpg"} />
      <Float floatingRange={[0, 0.15]} speed={4} rotationIntensity={0.1}>
        <Packaging
          isClosed={isClosed}
          setIsClosed={setIsClosed}
          position={[0, -0.5, 1]}
        />
      </Float>
    </>
  );
}
